<script>
    import API from '../../../../api';
    import {
        RESERVATION_TECHRESERVATION_CHANGE_TAX_ENDPOINT,
        RESERVATION_TECHRESERVATION_DELETE_TAX_ENDPOINT,
    } from '../../../../endpoints';
    import TechInfoTable from './tech-info-table.vue';
    import ActionsHeaderRendererAddItem from './actions-header-renderer-add-item.vue';
    import ActionsCellRendererRemoveItem from './actions-cell-renderer-delete-item.vue';
    import { toAmountDisplay } from '../../../../utils/numbers';

    export default {
        extends: TechInfoTable,
        components: {
            actionsHeaderRendererAddItem: ActionsHeaderRendererAddItem,
            actionsCellRendererRemoveItem: ActionsCellRendererRemoveItem,
        },
        data() {
            return {
                addModalId: `add-tax-modal-${this.reservationId}`,
                modalTitle: 'Add Tax',
                modalLabel: 'Tax',
                module: 'tax',
                editAutoWidthColumns: ['calculated_value'],
                columnDefs: [
                    {
                        headerName: '',
                        maxWidth: 60,
                        flex: 1,
                        sortable: false,
                        resizable: false,
                        cellClass: 'tech-info-remove-item',
                        headerComponent: 'actionsHeaderRendererAddItem',
                        headerComponentParams: {
                            addItem: () => {
                                this.showAddItem();
                            },
                            conditional: true,
                        },
                        cellRenderer: 'actionsCellRendererRemoveItem',
                        cellRendererParams: {
                            deleteItem: id => {
                                this.deleteItem(id, RESERVATION_TECHRESERVATION_DELETE_TAX_ENDPOINT);
                            },
                        },
                    },
                    {
                        headerName: 'Taxes',
                        sortable: false,
                        field: 'title',
                        flex: 1,
                        resizable: false,
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        headerName: 'Value',
                        sortable: false,
                        field: 'calculated_value',
                        flex: 1,
                        type: 'editableColumn',
                        cellRenderer: ({ data, value }) => {
                            if (!data.is_flat) {
                                if (data.is_reservation_tax) {
                                    return toAmountDisplay({
                                        amount: value,
                                        decimalPlaces: 3,
                                        percentage: true,
                                    });
                                } else {
                                    return toAmountDisplay({
                                        amount: value,
                                        decimalPlaces: 2,
                                        percentage: true,
                                    });
                                }
                            }
                            return toAmountDisplay({
                                amount: value,
                                currency: this.userCurrencySymbol,
                            });
                        },
                        cellEditorParams: ({ data, columnApi }) => ({
                            isDecimal: true,
                            maxDecimalPlaces: 3,
                            select: true,
                            selectOneOptions: [
                                { text: 'Fixed', value: true },
                                { text: 'Percentage', value: false },
                            ],
                            selectTwoOptions: [
                                { text: 'One-Time', value: 'ONETIME' },
                                { text: 'Daily', value: 'DAILY' },
                            ],
                            selectOneValue: data.is_flat,
                            selectTwoValue: data.frequency,
                            selectTwoVisibleCallback: selectOneValue => {
                                return selectOneValue;
                            },
                        }),
                        cellClass: 'text-primary lx-editable-cell ag-right-aligned-cell',
                        valueSetter: ({ newValue, data }) => {
                            if (
                                newValue[0] != data.calculated_value ||
                                newValue[1] != data.is_flat ||
                                newValue[2] != data.frequency
                            ) {
                                data.calculated_value = newValue[0];
                                data.is_flat = newValue[1];
                                data.frequency = newValue[2];
                                this.changeTaxValue(data.id, newValue[0], newValue[1], newValue[2]);
                            }
                        },
                        valueParser: (value) => {
                            return value.calculated_value;
                        },
                        resizable: false,
                        headerClass: 'ag-right-aligned-header',
                    },
                    {
                        headerName: 'Amount',
                        sortable: false,
                        field: 'money',
                        flex: 1,
                        resizable: false,
                        cellClass: 'ag-right-aligned-cell',
                        headerClass: 'ag-right-aligned-header',
                    },
                ],
            };
        },
        methods: {
            async changeTaxValue(id, value, isFlat, frequency) {
                this.busy = true;
                try {
                    await API.patch(RESERVATION_TECHRESERVATION_CHANGE_TAX_ENDPOINT(this.reservationId), {
                        id: id,
                        value: value,
                        is_flat: isFlat,
                        frequency: frequency,
                    });
                    await this.refreshReservationInvoice(this.metaReservationId);
                } catch (e) {
                    this.errorToast({ text: `Could not set tax value.` });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>
